export const UPDATE_TICKER_STOCK_QUOTE = "UPDATE_TICKER_STOCK_QUOTE";
export const UPDATE_TICKER_OPTION_QUOTE = "UPDATE_TICKER_OPTION_QUOTE";
